import axios from 'axios';
import {actions} from '../reducers/CustomersEntityTableReduser';

export const CUSTOMERS_LIST = 'customers/getCustomers';
export const CUSTOMERS_LIST_FOR_EXCEL = 'customers/getListForExcel';
export const ADD_EDIT_CUSTOMER = '/customers/addEditCustomer';
export const DELETE_CUSTOMER = 'customers/deleteCustomer';
export const RESTORE_CUSTOMER = 'customers/undeleteCustomer';

export const getCustomersList = action => ({
                                             customerName = '',
                                             customerType = -1,
                                             status = -1,
                                             deleted = 0,
                                             requestedPageNumber = 0,
                                             sortByField = 'customerID',
                                             sortByOrder = -1
                                           }) => dispatch => {

  const data = {
    customerName,
    customerType: parseInt(customerType, 10),
    status: parseInt(status, 10),
    deleted: deleted ? 1 : 0,
    requestedPageNumber: parseInt(requestedPageNumber, 10),
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };

  return axios.post(CUSTOMERS_LIST, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      const {
        totalPageCount,
        currentPageNumber,
        customers,
        totalResultCount
      } = body;

      dispatch(action({
        totalPageCount,
        currentPageNumber,
        customers,
        totalResultCount,
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};

export const getCustomersListForExcel = ({
                                           customerName = '',
                                           customerType = -1,
                                           status = -1,
                                           deleted = 0,
                                           sortByField = 'customerID',
                                           sortByOrder = -1
                                        }) => dispatch => {
  const data = {
    customerName,
    customerType: parseInt(customerType, 10),
    status: parseInt(status, 10),
    deleted: deleted ? 1 : 0,
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };
  return axios.post(CUSTOMERS_LIST_FOR_EXCEL, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      return body.list;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};

export const addCustomer = ({
                              customerID,
                              firstName,
                              lastName,
                              phone,
                              email,
                              address,
                              customerType,
                              idNumber,
                              genderID,
                              status
                            }) => (dispatch) => {

  const data = {
    customerID: parseInt(customerID, 10),
    firstName,
    lastName,
    phone,
    email,
    address,
    customerType: parseInt(customerType, 10),
    idNumber,
    genderID: parseInt(genderID, 10),
    status: parseInt(status, 10),
  };

  return axios.post(ADD_EDIT_CUSTOMER, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      const {customerID} = body.customerData;

      return customerID;
    });
};

export const deleteCustomer = (customerID) => dispatch => {

  return axios.post(DELETE_CUSTOMER, {customerID})
    .then(response => {
      const {errorCode} = response.data;

      if (errorCode === 0) {
        dispatch(actions.deleteCustomer({customerID}))
      } else {
        throw new Error();
      }

      return errorCode;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t delete customer';
    });
};

export const restoreCustomer = (customerID) => dispatch => {

  return axios.post(RESTORE_CUSTOMER, {customerID})
    .then(response => {
      const {errorCode} = response.data;

      if (errorCode === 0) {
        dispatch(actions.restoreCustomer({customerID}))
      } else {
        throw new Error();
      }

      return errorCode;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t restore customer';
    });
};

export const getCustomers = getCustomersList(actions.customersFetched);
export const getNextCustomers = getCustomersList(actions.customersAppended);
